import { lazy } from 'react';

const APTestScore = lazy(() => import('./modals/APTestScore'));
const SATGoalScoreModal = lazy(() => import('./modals/SATGoalScore'));
const PSATGoalScoreModal = lazy(() => import('./modals/PSATGoalScore'));
const ACTGoalScoreModal = lazy(() => import('./modals/ACTGoalScore'));
const PreACTGoalScoreModal = lazy(() => import('./modals/PreACTGoalScore'));
const SelfReportedSATandPSATScoreModal = lazy(
  () => import('./modals/SelfReportedSATandPSAT'),
);
const SelfReportedACTandPreACTScoreModal = lazy(
  () => import('./modals/SelfReportedACTandPreACT'),
);

export default {
  AP_TEST_SCORE: APTestScore,
  SAT_GOAL_SCORE_MODAL: SATGoalScoreModal,
  PSAT_GOAL_SCORE_MODAL: PSATGoalScoreModal,
  ACT_GOAL_SCORE_MODAL: ACTGoalScoreModal,
  PRE_ACT_GOAL_SCORE_MODAL: PreACTGoalScoreModal,
  SELF_REPORTED_SAT_AND_PSAT: SelfReportedSATandPSATScoreModal,
  SELF_REPORTED_ACT_AND_PreACT: SelfReportedACTandPreACTScoreModal,
};
